import {hasResource} from '../../../../utils/resourceAuth';
import {ResourceCode} from '../../../../constants/resourceCodes';

/**
 * DSP 申诉审核操作权限（提交审核结论）。
 *
 * 与后端 approveReviewTask / rejectReviewTask 的
 * @RequireResource(CS_DSP_APPEAL_REVIEW_OPERATE) 同判据。
 * 判据集中在此，避免表格勾选 / 批量按钮 / 详情抽屉三处各写一份导致漂移。
 *
 * 注意：查询与导出用菜单码 CS_DSP_APPEAL_REVIEW（能进页面即可），不受本权限限制。
 */
export const useReviewTaskCanOperate = (): boolean =>
    hasResource([ResourceCode.cs.CS_DSP_APPEAL_REVIEW_OPERATE]);
